class ContentCloser {
  constructor({ elm, app }) {
    this.elm = elm;
    this.app = app;

    this.elm.addEventListener('click', () => {
      this.app.close();
      return false;
    });
  }
}

export default ContentCloser;
